export const POSTS = [
  {
    slug: "it-hiring-india-2026",
    title: "The State of IT Hiring in India: What Employers Need to Know",
    excerpt:
      "India's technology talent market is deeper and more competitive than ever. Here is how hiring dynamics are shifting — and what it means for your next tech mandate.",
    category: "IT Recruitment",
    date: "July 2026",
    readTime: "5 min read",
    sections: [
      {
        h: "A market that rewards speed",
        paras: [
          "India remains one of the world's deepest technology talent pools, but the best candidates — senior engineers, data specialists, cloud and security professionals — rarely stay available for long. In most metro talent markets, a strong candidate is off the market within two to three weeks, often with multiple offers in hand.",
          "For employers, this means the hiring process itself has become a competitive factor. Organisations that take weeks to schedule interviews or days to share feedback consistently lose candidates to faster-moving competitors.",
        ],
      },
      {
        h: "Skills in demand",
        paras: ["Demand continues to concentrate around a few clusters of capability:"],
        bullets: [
          "Software development across full-stack, backend and platform engineering",
          "Data, analytics and AI/ML engineering",
          "Cloud, DevOps and site reliability",
          "Cybersecurity and infrastructure",
          "Product and project leadership for technology teams",
        ],
      },
      {
        h: "Quality of shortlist beats volume",
        paras: [
          "The most common hiring mistake we see is optimising for pipeline volume rather than pipeline quality. Ten carefully screened candidates will outperform fifty loosely matched profiles every time — in interview-to-offer ratio, in offer acceptance, and in the hiring manager's time.",
          "This is where a specialist recruitment partner adds leverage: targeted sourcing, structured screening against the actual role requirements, and shortlists that respect everyone's time.",
        ],
      },
      {
        h: "The Talentify view",
        paras: [
          "Technology hiring in India rewards employers who are clear about what they need, fast in how they evaluate, and realistic about the market. If you are planning technology hiring this quarter, our IT recruitment practice can help you move with both speed and precision.",
        ],
      },
    ],
  },
  {
    slug: "leadership-hiring-framework",
    title: "Leadership Hiring Done Right: A Framework for Senior Mandates",
    excerpt:
      "A wrong leadership hire costs far more than a delayed one. A structured approach to CXO and functional head searches protects both.",
    category: "Leadership Hiring",
    date: "July 2026",
    readTime: "6 min read",
    sections: [
      {
        h: "Why leadership hiring is different",
        paras: [
          "Senior hires shape strategy, culture and teams. The cost of a mis-hire at the CXO or functional head level is measured not just in compensation, but in lost quarters, team attrition and strategic drift. Yet many organisations run leadership searches with the same process they use for mid-level roles.",
          "Leadership hiring demands its own discipline: deeper requirement calibration, discreet market mapping, rigorous assessment and careful offer management.",
        ],
      },
      {
        h: "A framework that works",
        paras: ["Across our leadership mandates, four stages consistently separate successful searches from failed ones:"],
        bullets: [
          "Calibration: aligning all stakeholders on what the role must deliver in the first 12–24 months — before any sourcing begins",
          "Discreet mapping: identifying leaders who are performing, not just those who are looking",
          "Structured assessment: evaluating track record, leadership style and cultural fit against the organisation's actual context",
          "Close management: handling compensation, counter-offers and notice periods with the seniority they deserve",
        ],
      },
      {
        h: "Confidentiality is non-negotiable",
        paras: [
          "Senior searches often involve replacing an incumbent, entering a new market, or building a capability competitors should not know about. Every conversation — with candidates, references and the market — must be handled with discretion.",
          "This is a core part of how we work: leadership mandates are run quietly, with information shared strictly on a need-to-know basis.",
        ],
      },
      {
        h: "The Talentify view",
        paras: [
          "If you are planning a leadership hire — a manager, functional head or CXO — start with calibration, not with a job description. Our leadership hiring practice supports exactly these mandates across India.",
        ],
      },
    ],
  },
  {
    slug: "reduce-time-to-hire",
    title: "How to Reduce Time-to-Hire Without Compromising Quality",
    excerpt:
      "Slow hiring loses great candidates; rushed hiring makes bad ones. The answer is a tighter process, not a lower bar.",
    category: "Hiring Strategy",
    date: "July 2026",
    readTime: "5 min read",
    sections: [
      {
        h: "Where time-to-hire is actually lost",
        paras: [
          "Most hiring delays have little to do with candidate availability. They come from inside the process: unclear requirements, slow interview scheduling, delayed feedback, and offers that take days to approve.",
          "Mapping your own process honestly — from requirement sign-off to offer letter — usually reveals two or three stages that consume most of the delay.",
        ],
      },
      {
        h: "Five levers that make a difference",
        bullets: [
          "Define the role precisely before sourcing begins — a vague brief produces a vague shortlist",
          "Pre-align interview panels and decision criteria so feedback arrives within 24 hours",
          "Keep interview rounds to what is genuinely needed to decide",
          "Benchmark compensation early so offers are not re-negotiated internally at the end",
          "Stay in contact with candidates between stages — silence reads as disinterest",
        ],
        paras: [],
      },
      {
        h: "Speed is a candidate experience issue",
        paras: [
          "Candidates experience your hiring process as a preview of your organisation. A process that moves decisively signals a company that makes decisions; a process that drags signals the opposite. In a competitive market, that signal matters.",
        ],
      },
      {
        h: "The Talentify view",
        paras: [
          "Our end-to-end recruitment support is built around exactly these levers: structured requirement understanding, tight screening, proactive interview coordination and offer management through to joining. Faster hiring, without lowering the bar.",
        ],
      },
    ],
  },
];
